import { defineComponent as _defineComponent } from 'vue'
import { ref, onServerPrefetch, useRoute, onMounted } from '#app'
import { getPopularLocationsMachine } from '~/apps/popular-locations/inversify.config'
import { SearchFiltersUrl } from '~/apps/url/search-filters/SearchFiltersUrl'
import { PopularLocations } from '~/apps/search/popular-locations/schemas'
import { routeToFilters } from '~/apps/pu-links/infrastructure/routeToFilters'


export default /*#__PURE__*/_defineComponent({
  __name: 'PopularDestinations',
  setup(__props) {

const route = useRoute()
const locations = ref([] as PopularLocations[])

const fetchData = async () => {
  if (locations.value.length) {
    return
  }
  const filters = routeToFilters(route)
  const searchFilters = SearchFiltersUrl.filtersToUrl(filters).query
  return new Promise((resolve, reject) => {
    getPopularLocationsMachine(route.params.lang || 'en-gb', 16)
      .onTransition((state) => {
        if (state.context.locations) {
          locations.value = state.context.locations
        }
      })
      .onDone(() => resolve(true))
      .onStop(() => reject(new Error('Machine stopped unexpectedly')))
      .start()
      .send('FETCH', { searchFilters })
  })
}

// Fetch data on server-side rendering
onServerPrefetch(fetchData)

// Fetch data on client-side rendering
onMounted(fetchData)

return { __sfc: true,route, locations, fetchData }
}

})